import React, { Component, Fragment } from 'react';
import {
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';
import DatePicker from 'reactstrap-date-picker';
import CollapseCard from '../CollapseCard/CollapseCard';


class SearchNotes extends Component {
  render() {
    let categoryList = [];
    if (this.props.groupSelections.notes_category && this.props.notesCategories.length > 0) {
      categoryList = this.props.notesCategories
        .flatMap(parent => parent.children)
        .find(child => child.ID === parseInt(this.props.groupSelections.notes_category))?.list || [];

    }
    return (
      <CollapseCard title="Notes & Demographics" open={localStorage.getItem('searchNotesIsOpen') === 'true' || false} cb={(isOpen) => localStorage.setItem('searchNotesIsOpen', isOpen)}>
        <Row className='text-left'>
          <Col md={3}>
            <FormGroup>
              <Label>Notes Category</Label>
              <Input
                type="select"
                name="notes_category"
                onChange={e => this.props.handleCategoryInputChange(e)}
                value={this.props.groupSelections.notes_category || ''}
              > <option></option>
                {this.props.notesCategories.length > 0 ? this.props.notesCategories.map((parentCat) => (
                  <Fragment key={'notes_category_' + parentCat.ID}>
                    <option value={parentCat.ID}>{parentCat.type}</option>
                    {parentCat.children.map((childCat) => (
                      <option key={'notes_category_' + childCat.ID} value={childCat.ID}>- {childCat.type}</option>
                    ))}
                  </Fragment>
                ))
                  : <></>}
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Category Lists</Label>
              <Input
                type="select"
                disabled={categoryList.length === 0}
                name="notes_category_list"
                onChange={e => this.props.handleCategoryInputChange(e)}
                value={this.props.groupSelections.notes_category_list || ''}
              >
                <option></option>
                {categoryList.length > 0 ? categoryList.map(item => (
                  <Fragment key={'category_list_' + item.ID}>
                    <option value={item.ID}>{item.longDescription}</option>
                    {/* {parentCat.children.map((childCat) => (
                      <option key={'notes_category_' + childCat.ID} value={childCat.ID}>- {childCat.type}</option>
                    ))} */}
                  </Fragment>
                ))
                  : <></>}

              </Input>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>Notes Keyword Search</Label>
              <Input
                type="text"
                // onKeyPress={e => this.props.handleKeyUp(e)}
                name="notes_keyword"
                onChange={e => this.props.handleTextInputChange(e, false)}
                value={this.props.groupSelections.notes_keyword || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className='text-left'>
          <Col>
            <FormGroup>
              <Label>Notes Added/Modified Since</Label>
              <DatePicker
                clientToken={this.props.clientToken}
                name="notes_since"
                value={this.props.groupSelections.notes_since}
                //maxDate={new Date()}
                showClearButton={false}
                onChange={(v, f) => this.props.handleDatePickerChange({ target: { name: 'notes_since', value: v } })}
              />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>Notes Added/Modified Before</Label>
              <DatePicker
                clientToken={this.props.clientToken}
                name="notes_before"
                value={this.props.groupSelections.notes_before}
                //maxDate={new Date()}
                showClearButton={false}
                onChange={(v, f) => this.props.handleDatePickerChange({ target: { name: 'notes_before', value: v } })}
              />
            </FormGroup>
          </Col>
          {/* </Row>
          <Row className='text-left'> */}
          <Col>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="hasNotes"
                  checked={this.props.groupSelections.hasNotes}
                  onChange={e => this.props.onChange(e, ['hasNoNotes'])}
                /> Has Notes
              </Label>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="hasNoNotes"
                  checked={this.props.groupSelections.hasNoNotes}
                  onChange={e => this.props.onChange(e, ['hasNotes'])}
                /> Has No Notes
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </CollapseCard>
    );
  }
}

export default SearchNotes;